import React from "react";
import styled from "styled-components";

import { ContentStyles } from "./ContentStyles";
import { RichContentDisplayOptions } from "./RichContentDisplayOptions";
import { useRichContentRenderedForDisplay } from "./useRichContentRenderedForDisplay";

export type RichContentDisplayProps = Omit<
  React.HTMLProps<HTMLDivElement>,
  "ref" | "as" | "content"
> & {
  content: string | null | undefined;
  options?: RichContentDisplayOptions;
  wrapper?: (html: JSX.Element) => JSX.Element;
  inline?: boolean;
};

const ContentWrapper = styled.span<{ inline?: boolean }>`
  display: ${(p) => (p.inline ? "inline-block" : "block")};
`;

const _RichContentDisplay = React.forwardRef<
  HTMLDivElement,
  RichContentDisplayProps
>(({ content, options, wrapper, ...divProps }, ref) => {
  const reactContent = useRichContentRenderedForDisplay(content, options);

  return (
    <ContentStyles>
      <ContentWrapper ref={ref} {...divProps}>
        {wrapper ? wrapper(reactContent) : reactContent}
      </ContentWrapper>
    </ContentStyles>
  );
});

const RichContentDisplay = styled(_RichContentDisplay)``;

export default RichContentDisplay;
